import React, { useEffect, useRef } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Layout from "./Components/Layout";
import Analytics from "./Pages/Analytics/Index";
import Dashboard from "./Pages/Dashboard";
import Heatmap from "./Pages/Heatmap";
import HistoricMap from "./Pages/HistoricMap";
import Login from "./Pages/Login";
import Map from "./Pages/Map";
import ProtectedRoutes from "./Pages/ProtectedRoutes";
import UserAnalytics from "./Pages/Analytics/Users";
import AircraftAnalytics from "./Pages/Analytics/Aircrafts";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <ProtectedRoutes />,
      children: [
        { path: "/", element: <Dashboard /> },
        { path: "/map", element: <Map /> },
        { path: "/historic-map", element: <HistoricMap /> },
        { path: "/heatmap", element: <Heatmap /> },
        {
          path: "/analytics",
          children: [
            { path: "users", element: <UserAnalytics /> },
            { path: "aircrafts", element: <AircraftAnalytics /> },
          ],
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
      <Tooltip id="default" className="z-50" />{" "}
    </>
  );
};

export default App;
